import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-white border-t border-slate-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Company info */}
          <div className="text-center md:text-left">
            <p className="text-sm text-slate-600">
              {t('footer.copyright', { year: currentYear })}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link
              to="/privacy"
              className="text-sm text-slate-600 hover:text-primary-700 transition-colors"
            >
              {t('footer.links.privacy')}
            </Link>
            <Link
              to="/terms"
              className="text-sm text-slate-600 hover:text-primary-700 transition-colors"
            >
              {t('footer.links.terms')}
            </Link>
            <Link
              to="/about"
              className="text-sm text-slate-600 hover:text-primary-700 transition-colors"
            >
              {t('footer.links.about')}
            </Link>
            <a
              href="mailto:acmh360@gmail.com"
              className="text-sm text-slate-600 hover:text-primary-700 transition-colors"
            >
              {t('footer.contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
